/***
 * Created on 2024/11/18
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import {I18nextProvider, useTranslation} from "react-i18next";
import sharedI18n from "common/SharedI18n";
import {QueryClient, QueryClientProvider, useMutation, useQuery} from "@tanstack/react-query";
import {apiDelete, apiGet} from "../service/api";
import {useBoundedStore} from 'common/Store';
import {getErrorMessage} from 'common/ServiceCommon';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});


function DeleteQidWarning(props) {
    const { t } = useTranslation();
    const [disabled, setDisabled] = React.useState(true);
    const store = useBoundedStore();

    const validate = () => {
        const allCheckbox = document.querySelectorAll('input[type=checkbox]');
        const checked = document.querySelectorAll('input[type=checkbox]:checked');
        const allChecked = allCheckbox.length === checked.length;
        setDisabled(!allChecked);
    }

    const onDeleteMutate = useMutation({
        mutationFn: async (data) => await apiDelete('/ajax/confirm_delete_qid_account', data),
        onSuccess: data => {
            location.href = '/delete-qid-success';
        },
        onError: (error, variables, context) => {
            store.globalAlert.setAlert(getErrorMessage(t, error.cause?.code), 'error', true);
        }
    });

    const onDelete = async () => {
        store.globalAlert.setAlert('', '', false);
        const data = {
            revoke_token: location.pathname.split('/')?.[2]
        }
        await onDeleteMutate.mutateAsync(data);
    }

    const checkWarningInput = [
        t('@Your purchased SSL certificate licenses on myQNAPcloud will be deleted.@'),
        t('@All your devices registered under this account will be deleted.@'),
        t('@You will nolonger have myQNAPcloud remote access services to all your devices.@'),
        t('@All the existing myQNAPcloud sharing links will become invalid.@'),
        t('@You will not recieve notification on your paired mobile devices.@'),
        t('@All of the contacts associated with this account will be deleted.@'),
        t('@Your files and folders in myQNAPcloud Storage will be permanently deleted.@')
    ];

    return (
        <section className="common-page-wrapper">
            <div className="common-page-header">{t('@Permanently Delete Account@')}</div>
            <div className="common-page-body">
                <p>{t('@Please note the following@')}:</p>
                <div className="common-info-grid">
                    <div className="common-info-grid__row !no-border-bottom">
                        {t('@Once you delete your account, any data associated with your deleted account cannot be recovered.@')}
                    </div>
                    {
                        checkWarningInput.map((item, index) => (
                            <div className="common-info-grid__row" key={index}>
                                <div className="comp-checkbox">
                                    <label className="q-checkbox">
                                        <input type="checkbox" name="checkbox-checked" onClick={validate}/>
                                        <span className="">{item}</span>
                                    </label>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>

            <div className="common-page-footer">
                <div className="q-btn-group btn-align-right">
                    <button className="q-btn q-btn--primary btn-medium btn-rounded-normal"
                            onClick={onDelete} disabled={disabled}>{t('@Confirm@')}</button>
                </div>
            </div>
        </section>
    );
}

const DeleteQidWarningIndex = () => {
    return (
        <I18nextProvider i18n={sharedI18n}>
            <QueryClientProvider client={queryClient}>
                <DeleteQidWarning/>
            </QueryClientProvider>
        </I18nextProvider>
    )
}

export default DeleteQidWarningIndex;